import loadable from '@loadable/component';
import LoadingComponentLoadable from '../../components/Loading/Lazy';

const QueueLoadable = loadable(() => import(/* webpackChunkName: "queue-page" */ './index'), {
  fallback: <LoadingComponentLoadable />,
});

export default QueueLoadable;
